import React from "react"
import { navigate } from "gatsby"
import PropTypes from "prop-types"
import {
  filtersTaxoItem,
  filtersTaxoItemChildrenContainer,
  taxoChildren,
  taxoChildrenParentContainer,
} from "../styles/listAdresses.module.scss"
import {
  AdressItemTaxo,
  AdressItemTaxoNotClickable,
} from "../listItems/styled-components/adresse-item-styled"
import { AllBtn } from "gatsby-theme-lantana/src/gatsby-theme-blank/templates/list/listItems/styled-components/adresse-item-styled"

export const FiltreTaxo = ({
  setChoosenTaxo,
  setChoosenTaxoObject,
  setChildrenFinalTaxo,
  choosenTaxo,
  choosenTaxoObject,
  childrenFinalTaxo,
  finalTaxo,
  relatedTaxos,
  toggleTaxo,
  style,
  mobile,
  lantana,
  isVisible,
}) => {
  if (!isVisible) {
    return null
  }
  return (
    <>
      {choosenTaxoObject && choosenTaxoObject.children ? (
        <div className={taxoChildren}>
          <div className={taxoChildrenParentContainer}>
            <AdressItemTaxoNotClickable
              onClick={() => {
                setChoosenTaxo(null)
                setChoosenTaxoObject()
                setChildrenFinalTaxo()
                navigate("/adresses")
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  setChoosenTaxo(null)
                  setChoosenTaxoObject()
                  setChildrenFinalTaxo()
                  navigate("/adresses")
                }
              }}
              aria-label={choosenTaxo + " - Supprimer le filtre actif"}
              active={true}
              aria-expanded={true}
              className={filtersTaxoItem}
            >
              {choosenTaxo}
            </AdressItemTaxoNotClickable>
            {mobile === true && lantana === true ? (
              <AllBtn
                style={style}
                className="btn"
                onClick={() => {
                  setChoosenTaxo(null)
                  setChoosenTaxoObject()
                  setChildrenFinalTaxo()
                  navigate("/adresses")
                }}
              >
                Afficher tous les mots-clés
              </AllBtn>
            ) : mobile === true && !lantana ? (
              <button
                style={style}
                className="btn"
                onClick={() => {
                  setChoosenTaxo(null)
                  setChoosenTaxoObject()
                  setChildrenFinalTaxo()
                  navigate("/adresses")
                }}
              >
                Afficher tous les mots-clés
              </button>
            ) : null}
          </div>
          <div className={filtersTaxoItemChildrenContainer}>
            <ul>
              <li>
                <AdressItemTaxo
                  onClick={() => {
                    if (childrenFinalTaxo) {
                      if (childrenFinalTaxo.includes(choosenTaxoObject.name)) {
                        const value = childrenFinalTaxo.filter(
                          (taxo) => taxo !== choosenTaxoObject.name
                        )
                        setChildrenFinalTaxo(value)
                      } else {
                        setChildrenFinalTaxo((ancientValue) => {
                          return [...ancientValue, choosenTaxoObject.name]
                        })
                      }
                    } else if (finalTaxo.includes(choosenTaxoObject.name)) {
                      const value = finalTaxo.filter(
                        (taxo) => taxo !== choosenTaxoObject.name
                      )
                      setChildrenFinalTaxo(value)
                    }
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      if (childrenFinalTaxo) {
                        if (
                          childrenFinalTaxo.includes(choosenTaxoObject.name)
                        ) {
                          const value = childrenFinalTaxo.filter(
                            (taxo) => taxo !== choosenTaxoObject.name
                          )
                          setChildrenFinalTaxo(value)
                        } else {
                          setChildrenFinalTaxo((ancientValue) => {
                            return [...ancientValue, choosenTaxoObject.name]
                          })
                        }
                      } else if (finalTaxo.includes(choosenTaxoObject.name)) {
                        const value = finalTaxo.filter(
                          (taxo) => taxo !== choosenTaxoObject.name
                        )
                        setChildrenFinalTaxo(value)
                      }
                    }
                  }}
                  active={
                    childrenFinalTaxo
                      ? childrenFinalTaxo.includes(choosenTaxoObject.name)
                      : true
                  }
                  aria-label={
                    !childrenFinalTaxo ||
                    childrenFinalTaxo.includes(choosenTaxoObject.name)
                      ? choosenTaxoObject.name + " - Supprimer le filtre actif"
                      : "Filtrer sur la taxonomie '" +
                        choosenTaxoObject.name +
                        "'"
                  }
                  parent={false}
                  className={filtersTaxoItem}
                >
                  {choosenTaxoObject.name}
                </AdressItemTaxo>
              </li>
              {choosenTaxoObject.children.map((element, key) => (
                <li key={key}>
                  <AdressItemTaxo
                    onClick={() => {
                      if (childrenFinalTaxo) {
                        if (childrenFinalTaxo.includes(element.name)) {
                          const value = childrenFinalTaxo.filter(
                            (taxo) => taxo !== element.name
                          )
                          setChildrenFinalTaxo(value)
                        } else {
                          setChildrenFinalTaxo((ancientValue) => {
                            return [...ancientValue, element.name]
                          })
                        }
                      } else if (finalTaxo.includes(element.name)) {
                        const value = finalTaxo.filter(
                          (taxo) => taxo !== element.name
                        )
                        setChildrenFinalTaxo(value)
                      }
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        if (childrenFinalTaxo) {
                          if (childrenFinalTaxo.includes(element.name)) {
                            const value = childrenFinalTaxo.filter(
                              (taxo) => taxo !== element.name
                            )
                            setChildrenFinalTaxo(value)
                          } else {
                            setChildrenFinalTaxo((ancientValue) => {
                              return [...ancientValue, element.name]
                            })
                          }
                        } else if (finalTaxo.includes(element.name)) {
                          const value = finalTaxo.filter(
                            (taxo) => taxo !== element.name
                          )
                          setChildrenFinalTaxo(value)
                        }
                      }
                    }}
                    active={
                      childrenFinalTaxo
                        ? childrenFinalTaxo.includes(element.name)
                        : finalTaxo.includes(element.name)
                    }
                    className={filtersTaxoItem}
                    aria-label={
                      (
                        childrenFinalTaxo
                          ? childrenFinalTaxo.includes(element.name)
                          : finalTaxo.includes(element.name)
                      )
                        ? element.name + " - Supprimer le filtre actif"
                        : "Filtrer sur la taxonomie '" + element.name + "'"
                    }
                  >
                    {element.name}
                  </AdressItemTaxo>
                </li>
              ))}
            </ul>
          </div>
          {mobile === false && lantana === true ? (
            <AllBtn
              style={style}
              className="btn"
              onClick={() => {
                setChoosenTaxo(null)
                setChoosenTaxoObject()
                setChildrenFinalTaxo()
                navigate("/adresses")
              }}
            >
              Afficher tous les mots-clés
            </AllBtn>
          ) : mobile === false && !lantana ? (
            <button
              style={style}
              className="btn"
              onClick={() => {
                setChoosenTaxo(null)
                setChoosenTaxoObject()
                setChildrenFinalTaxo()
                navigate("/adresses")
              }}
            >
              Afficher tous les mots-clés
            </button>
          ) : null}
        </div>
      ) : (
        <>
          {relatedTaxos.map((element, key) => {
            let activeBool = false
            if (finalTaxo === element.name) {
              activeBool = true
            }
            return (
              <li key={key}>
                <AdressItemTaxo
                  tabIndex="0"
                  onClick={() => {
                    toggleTaxo(finalTaxo, element.name)
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      toggleTaxo(finalTaxo, element.name)
                    }
                  }}
                  active={activeBool}
                  parent={element.children?.length > 0}
                  className={filtersTaxoItem}
                  aria-label={
                    activeBool
                      ? element.name + " - Supprimer le filtre actif"
                      : "Filtrer sur la taxonomie '" + element.name + "'"
                  }
                  aria-expanded={element.children?.length > 0 ? false : null}
                >
                  {element.name}
                </AdressItemTaxo>
              </li>
            )
          })}
        </>
      )}
    </>
  )
}

FiltreTaxo.propTypes = {
  setChoosenTaxo: PropTypes.func,
  setChoosenTaxoObject: PropTypes.func,
  setChildrenFinalTaxo: PropTypes.func,
  choosenTaxo: PropTypes.string,
  choosenTaxoObject: PropTypes.object,
  childrenFinalTaxo: PropTypes.array,
  finalTaxo: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  relatedTaxos: PropTypes.array,
  toggleTaxo: PropTypes.func,
  style: PropTypes.object,
  mobile: PropTypes.bool,
  lantana: PropTypes.bool,
  isVisible: PropTypes.bool,
}
